import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";

interface StatusItemProps {
  label: string;
  value: string;
  unit: string;
  onClick?: () => void;
  icon?: React.ReactNode;
}

export const StatusItem = ({ label, value, unit, onClick, icon }: StatusItemProps) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        "flex flex-col items-center gap-2 py-1.5",
        onClick && "cursor-pointer transition-opacity active:opacity-70",
      )}
    >
      <span className={cn(textVariants.footnote)}>{label}</span>
      <span className={cn(textVariants.title3, "flex items-center gap-1")}>
        {value} {unit} {icon}
      </span>
    </div>
  );
};
